import { toZonedTime } from "date-fns-tz";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";

import type { OrderQuery } from "~/graphql/graphql-new.gen";
import { OrderTagReship } from "~/graphql/graphql-new.gen";
import { brandState } from "~/stores/brand";
import { formatDate } from "~/utils/date";

import { OrderReshipBadge } from "./order-reship-badge";
import { TrackingViewReship } from "./tracking-view-reship";

type OrderReshipDetailsProps = {
  tags: OrderQuery["order"]["tags"];
  reshipOrder: OrderQuery["order"]["reshipOrder"];
  reshipOrderId?: OrderQuery["order"]["reshipOrderId"];
};

export const OrderReshipDetails: React.FC<OrderReshipDetailsProps> = ({
  reshipOrder,
  reshipOrderId,
  tags,
}: OrderReshipDetailsProps) => {
  const brand = useAtomValue(brandState);
  const { i18n, t } = useTranslation();

  if (tags.reship === OrderTagReship.None) return null;

  return (
    <div className="rounded border border-gray-300">
      <div className="flex items-center justify-between border-b border-gray-300 px-6 py-4">
        <OrderReshipBadge tag={tags.reship} />

        {reshipOrder?.createdAt ? (
          <p className="text-xs text-[#767A7C]">
            {t("order.reship.created_at", {
              date: formatDate(
                brand?.timezone
                  ? toZonedTime(new Date(reshipOrder.createdAt), brand.timezone)
                  : new Date(reshipOrder.createdAt),
                i18n.language.replace("_", "-"),
                {
                  day: "numeric",
                  month: "numeric",
                  year: "2-digit",
                },
              ),
              interpolation: { escapeValue: false },
            })}
          </p>
        ) : null}
      </div>
      <div className="p-6 pt-4">
        <div className="flex flex-col">
          <p className="text-sm text-gray-900">
            {t("order.reship.created_following_claim")}
          </p>
          <TrackingViewReship reshipOrderId={reshipOrderId} />
        </div>
      </div>
    </div>
  );
};
